import React from "react";
import CopilotPage from "app/audit/AI/Copilot";

const NoraWorkflow = () => {
  return <CopilotPage />;
};

export default NoraWorkflow;
